import { useServiceError } from '@/hooks';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { createMessage } from './Message.service';

export function useMessageCreate() {
  const mutation = useMutation(createMessage, {
    onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Notificação criada com sucesso!',
      });
    },
  });

  useServiceError(mutation.error);

  return mutation;
}
